import { AppNotification } from '@fuse/types/notification';
import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { NotificationsService } from '@fuse/services/notifications/notifications.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FuseNavigationService } from '../navigation/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'notifications-toolbar',
    templateUrl: './notifications-toolbar.component.html',
    styleUrls: ['./notifications-toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NotificationsToolbarComponent implements OnInit, OnDestroy {

    public _unsubscribeAll: Subject<any>;
    public newNotificationCount: number;
    public newNotifications = [];
    lang = localStorage.getItem('lang') || 'sr';
    categories = [3, 6, 15, 16, 17, 18];

    constructor(
        private _notificationsService: NotificationsService,
        private _fuseNavigationService: FuseNavigationService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        this._unsubscribeAll = new Subject();
    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getMultipleTranslationCategories(this.lang, this.categories);
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    notificationClicked(): void {
        this._notificationsService.toolbarListClick();
    }


    ngOnInit(): void {
        this._notificationsService.onNotificationsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((newNotificationCount) => {
                this.newNotificationCount = newNotificationCount;

                // const badgeValue = newNotificationCount > 0 ? { title: newNotificationCount, bg: '#EC0C8E', fg: '#FFFFFF' } : null;
                // this._fuseNavigationService.updateNavigationItem('notifications', {
                //     badge: badgeValue
                // });

            });

        this._notificationsService.newNotifications
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((newNotifications) => {
                if (newNotifications['data']) {
                    this.newNotifications = newNotifications['data']['result'];
                    
                } else {
                    this.newNotifications = [];
                }
                // const notifications = this.newNotifications;
                this.newNotifications.forEach((notification) => {
                    let message = '';
                    let message2 = '';
                    let message3 = '';
                    let message4 = '';
                    if ((notification.data.message.match(/%/g) || []).length < 2) {
                        message = notification.data.message;
                    }
                    else {
                        if ((notification.data.message.match(/%/g) || []).length >= 4) {
                            message = notification.data.message.split('%').slice(0, 1)[0];
                            message2 = notification.data.message.split('%').slice(1, 2)[0];
                            message3 = notification.data.message.split('%').slice(2, 3)[0];
                            message4 = notification.data.message.split('%').slice(3, 4)[0];
                        }         
                        else {
                            message = notification.data.message.split('%').slice(0, 1)[0];
                            message2 = notification.data.message.split('%').slice(1, 2)[0];

                        }   

                    }
                    notification.data.message = message;
                    notification.data.message2 = message2;
                    notification.data.message3 = message3;
                    notification.data.message4 = message4;
                    // use setTranslation() with the third argument set to true
                    // to append translations instead of replacing them
                });
            });

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
        this.getTranslations();
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
